module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row provision-table",
    class: _vm.showSettlementTypeClass()
  }, [_vm._m(0), _vm._v(" "), (_vm.showProvisionFor('cps')) ? _c('div', {
    staticClass: "col s12 indicator-row"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-wallet",
      "stats": _vm.showProvisionFor('cps'),
      "unit": "zł"
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', {
    staticClass: "provision-type-info"
  }, [_vm._v("\n          CPS\n          "), _c('span', {
    attrs: {
      "data-balloon-pos": "up",
      "data-balloon": "Sprzedana polisa"
    }
  }, [_c('i', {
    staticClass: "mfind-icon-info icon"
  })])])])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.showProvisionFor('cpl')) ? _c('div', {
    staticClass: "col s12 indicator-row"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-wallet",
      "stats": _vm.showProvisionFor('cpl'),
      "unit": "zł"
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', {
    staticClass: "provision-type-info"
  }, [_vm._v("\n          CPL\n          "), _c('span', {
    attrs: {
      "data-balloon-pos": "up",
      "data-balloon": "Potwierdzona kalkulacja"
    }
  }, [_c('i', {
    staticClass: "mfind-icon-info icon"
  })])])])], 2)], 1) : _vm._e(), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.getUserPending
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s12 headline center"
  }, [_c('h1', [_vm._v("Tabela wynagrodzeń")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d04cc4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/provisionTable.vue
// module id = 388
// module chunks = 0